import React from 'react'
import classNames from 'classnames'
import {
  ShimmerFieldGroupProps,
  ShimmerProps,
  ShimmerSectionProps,
} from './LoadingState.types'
import css from './LoadingState.styles.scss'

const Shimmer: React.FC<ShimmerProps> = ({ className }) => (
  <div className={classNames(css.LoadingState__Shimmer, className)} />
)

const ShimmerSection: React.FC<ShimmerSectionProps> = ({
  children,
  className,
  orientation,
}) => (
  <div
    className={classNames(
      css.LoadingState__ShimmerSection,
      {
        [css.LoadingState__ShimmerSection__Row]: orientation === 'row',
        [css.LoadingState__ShimmerSection__Column]: orientation === 'col',
      },
      className
    )}
  >
    {children}
  </div>
)

const ShimmerField: React.FC = () => (
  <ShimmerSection className={css.LoadingState__ShimmerField} orientation="col">
    <Shimmer className={css.LoadingState__ShimmerField__Label} />
    <Shimmer className={css.LoadingState__ShimmerField__Value} />
  </ShimmerSection>
)

const ShimmerFieldGroup: React.FC<ShimmerFieldGroupProps> = ({
  children,
  className,
}) => (
  <div className={classNames(css.LoadingState__ShimmerFieldGroup, className)}>
    {children}
  </div>
)

const ShimmerGiftSummary: React.FC = () => (
  <ShimmerFieldGroup
    className={css.LoadingState__ShimmerGiftSummary__FieldGroup}
  >
    <ShimmerSection
      className={css.LoadingState__ShimmerGiftSummary}
      orientation="row"
    >
      <Shimmer className={css.LoadingState__ShimmerGiftSummary__Image} />
      <ShimmerSection
        className={css.LoadingState__ShimmerGiftSummary__Fields}
        orientation="col"
      >
        <Shimmer className={css.LoadingState__ShimmerGiftSummary__Top} />
        <Shimmer className={css.LoadingState__ShimmerGiftSummary__Middle} />
        <Shimmer className={css.LoadingState__ShimmerGiftSummary__Bottom} />
      </ShimmerSection>
    </ShimmerSection>
    <ShimmerField />
  </ShimmerFieldGroup>
)

const Separator: React.FC = () => (
  <div className={css.LoadingState__Separator} />
)

const LoadingState: React.FC = () => (
  <div
    className={css.LoadingState}
    data-testid="GiftDetailsDrawer__LoadingState"
  >
    <ShimmerGiftSummary />
    <ShimmerSection orientation="col">
      <ShimmerFieldGroup>
        <ShimmerField />
        <ShimmerField />
      </ShimmerFieldGroup>
      <Separator />
      <ShimmerFieldGroup>
        <ShimmerField />
        <ShimmerField />
        <ShimmerField />
      </ShimmerFieldGroup>
    </ShimmerSection>
  </div>
)

export default LoadingState
